"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataMigrationLogListApi = dataMigrationLogListApi;
exports.dataMigrationUploadApi = dataMigrationUploadApi;
exports.getFudouCardListByAppIdApi = getFudouCardListByAppIdApi;
exports.getMigrationTaskStatusApi = getMigrationTaskStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 数据迁移 - 上传迁移文件并执行数据迁移
 * @param {FormData} formData - 表单数据
 * @returns {ImportTaskResult} 任务结果（含 taskId）
 */
function dataMigrationUploadApi(formData) {
  return (0, _request.default)({
    url: '/admin/customer/data-migration/upload',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData,
    timeout: 60000
  });
}

/**
 * 数据迁移 - 查询迁移日志列表
 * @param {Object} params - 查询参数
 */
function dataMigrationLogListApi(params) {
  return (0, _request.default)({
    url: '/admin/customer/data-migration/log/list',
    method: 'get',
    params: params
  });
}

/**
 * 数据迁移 - 根据小程序ID获取福卡列表（eb_fudou_card表）
 * @param {number} appId - 小程序ID
 */
function getFudouCardListByAppIdApi(appId) {
  return (0, _request.default)({
    url: '/admin/customers/integral/fudou-card-list',
    method: 'get',
    params: {
      appId: appId
    }
  });
}

/**
 * 数据迁移 - 查询迁移任务状态（轮询）
 * @param {string} taskId - 任务ID
 */
function getMigrationTaskStatusApi(taskId) {
  return (0, _request.default)({
    url: "/admin/customer/data-migration/status/".concat(taskId),
    method: 'get'
  });
}